import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      style={{
        background: "#111827",
        borderTop: "1px solid #1C2536",
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="md:flex md:justify-between">
          <div className="mb-8 md:mb-0">
            <p className="text-sm" style={{ color: "#4A5568" }}>
              &copy; 2025 Parlaye Inc.
            </p>
          </div>
          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3">
            <div>
              <h3
                className="text-xs font-bold uppercase mb-4"
                style={{ color: "#8B95A8", letterSpacing: "0.06em" }}
              >
                Company
              </h3>
              <ul className="space-y-3">
                <li>
                  <a
                    href="#download"
                    className="text-sm transition-colors duration-200"
                    style={{ color: "#4A5568" }}
                    onMouseEnter={(e) => (e.currentTarget.style.color = "#F1F5F9")}
                    onMouseLeave={(e) => (e.currentTarget.style.color = "#4A5568")}
                  >
                    Download
                  </a>
                </li>
                <li>
                  <a
                    href="#about"
                    className="text-sm transition-colors duration-200"
                    style={{ color: "#4A5568" }}
                    onMouseEnter={(e) => (e.currentTarget.style.color = "#F1F5F9")}
                    onMouseLeave={(e) => (e.currentTarget.style.color = "#4A5568")}
                  >
                    About
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h3
                className="text-xs font-bold uppercase mb-4"
                style={{ color: "#8B95A8", letterSpacing: "0.06em" }}
              >
                Resources
              </h3>
              <ul className="space-y-3">
                <li>
                  <a
                    href="#how-it-works"
                    className="text-sm transition-colors duration-200"
                    style={{ color: "#4A5568" }}
                    onMouseEnter={(e) => (e.currentTarget.style.color = "#F1F5F9")}
                    onMouseLeave={(e) => (e.currentTarget.style.color = "#4A5568")}
                  >
                    How it Works
                  </a>
                </li>
                <li>
                  <Link
                    to="/privacypolicy"
                    className="text-sm transition-colors duration-200"
                    style={{ color: "#4A5568" }}
                    onMouseEnter={(e) => (e.currentTarget.style.color = "#F1F5F9")}
                    onMouseLeave={(e) => (e.currentTarget.style.color = "#4A5568")}
                  >
                    Privacy Policy
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h3
                className="text-xs font-bold uppercase mb-4"
                style={{ color: "#8B95A8", letterSpacing: "0.06em" }}
              >
                Support
              </h3>
              <ul className="space-y-3">
                <li>
                  <a
                    href="https://help.parlaye.com/"
                    className="text-sm transition-colors duration-200"
                    style={{ color: "#4A5568" }}
                    onMouseEnter={(e) => (e.currentTarget.style.color = "#F1F5F9")}
                    onMouseLeave={(e) => (e.currentTarget.style.color = "#4A5568")}
                  >
                    Support
                  </a>
                </li>
                <li>
                  <Link
                    to="/termsofuse"
                    className="text-sm transition-colors duration-200"
                    style={{ color: "#4A5568" }}
                    onMouseEnter={(e) => (e.currentTarget.style.color = "#F1F5F9")}
                    onMouseLeave={(e) => (e.currentTarget.style.color = "#4A5568")}
                  >
                    Terms Of Use
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
